
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component
export default class InteriorColorField extends Vue {
  val = '';

  @Prop()
  value!: any;

  @Prop()
  readonly!: boolean;

  @Watch('value')
  watchValue() {
    this.val = String(this.value);
  }

  @Watch('val')
  watchVal() {
    if (this.val) {
      this.$emit('update', this.val);
    }
  }

  mounted() {
    this.watchValue();
  }

  @Prop()
  disabled!: boolean;
}
